import React, { useState, useEffect } from 'react'
import Pagination from '@mui/material/Pagination';
import NodataImage from '../../../../../../images/nodata.png';
import { paginationFuction } from '../../CommonUtils';
import PiePage from '../../CommonComponents/PiePage.component'
import InputField from '../../CommonComponents/InputMUI'
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import Loader from '../../../../../presentationals/Loader/Loader.component';
import Popup from '../../../../../presentationals/Popup/Popup.component'
import { SaveUpdateDocumentTempConfig, getDocumentTempCountByPageEntry, getDocumentTempListByPageEntry, DeleteDocumentTempId } from '../ActionCreator';
const itemsPerPage = 10;

export default function AddDocName() {
    const [loader, setLoader] = useState(false)
    const [view, setView] = useState("list")
    const [tableData, setTableData] = useState([])
    const [currentPage, setcurrentPage] = useState(1);
    const [documentName, setdocumentName] = useState("");
    const [totalcount, setTotalcount] = useState(0)
    const [showPopup, setShowPopup] = useState({ show: false, popupStatus: "" })
    const [editData, setEditData] = useState({})
    const actionHandler = (type, data) => {
        if (type == "add") {
            setView("add")
            setcurrentPage(1)
        }
        else if (type === "list") {
            setEditData({})
            setdocumentName("")
            setcurrentPage(1)
            setView("list")
        } else if (type === "delete") {
            DocNameDeleteAPi(data)

        } else if (type === "edit") {
            setEditData(data)
            setdocumentName(data?.docName)
            setView("edit")
            setcurrentPage(1)
        }
    }

    const handlePageChange = (event, value) => {
        setcurrentPage(value)
        DocListAPI(value)
    }

    useEffect(() => {
        TotalcountAPi()
        DocListAPI(currentPage)
    }, [])
    useEffect(() => {
        if (view === "list") {
            TotalcountAPi()
            DocListAPI(currentPage)
        }
    }, [view])

    const TotalcountAPi = () => {
        setLoader(true)
        getDocumentTempCountByPageEntry(callBack => {
            setLoader(false)
            console.log("callBack", callBack)
            setTotalcount(callBack)
        })
    }

    const DocNameDeleteAPi = (data) => {
        setLoader(true)
        DeleteDocumentTempId(data?.id, callBack => {
            console.log("call", callBack)
            setLoader(false)
            if (callBack == "success") {
                setShowPopup({ show: true, popupStatus: "Document Name Deleted Successfully" })
                DocListAPI(currentPage)
            } else {
                setShowPopup({ show: true, popupStatus: "Error Deleting Document Name" })
            }
            removePopup()
        })
    }

    const DocListAPI = (page) => {
        setLoader(true)
        getDocumentTempListByPageEntry(page, itemsPerPage, callBack => {
            setLoader(false)
            console.log(callBack)
            if (callBack) {
                setTableData(callBack)
            } else {
                setTableData([])
            }
        })
    }

    const saveHandler = () => {
        const data = { docName: documentName }
        if (view === "edit") {
            data.documentId = editData?.documentId
            data.addedOn = editData?.addedOn
            data.id = editData?.id
        }

        setLoader(true)
        SaveUpdateDocumentTempConfig(data, callBack => {
            setLoader(false)
            console.log("callback", callBack)
            if (callBack == "success") {
                setEditData({})
                setdocumentName('')
                setView("list")
            } else {
                setShowPopup({ show: true, popupStatus: "Error Saving Document Name" })
            }
            removePopup()
        })
    }

    const getDates = (time) => {

        const date = new Date(time);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    }

    const closePopup = () => {
        setShowPopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    return (
        <>
            {
                loader ? <Loader /> : ''
            }
            {
                showPopup?.show ?
                    <Popup popupStatus={showPopup?.popupStatus} closePopup={closePopup} />
                    : ''}
            {
                view === "list" ?
                    <div className="container-fluid" style={{ marginTop: '30px' }}>
                        <div className="row">
                            <div className="col-sm-2 col-xs-4">
                                <button onClick={e => actionHandler('add', "")} className='cred-btn center-block' style={{ padding: '10px 15px', background: '#064254', borderRadius: '8px', border: '1px solid #064254', color: '#fff' }}><i class="fa fa-plus" aria-hidden="true"></i></button>
                            </div>
                            <div className="col-xs-12" style={{ marginTop: '30px' }}>
                                <div className='table-responsive full-height'>
                                    {tableData?.length > 0 ?
                                        <>
                                            <div style={{ overflowX: 'auto' }}>
                                                <table className='table credhub-table'>
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Document ID</th>
                                                            <th scope="col">Document Name</th>
                                                            <th scope="col">Added On</th>
                                                            <th scope="col">Edit</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {tableData?.map((row, i) => {
                                                            return (
                                                                <tr key={i}>


                                                                    <td>{row?.documentId}</td>
                                                                    <td>{row?.docName}</td>
                                                                    <td>{getDates(row?.addedOn)}</td>
                                                                    <td>
                                                                        <button className='btn action-btn' onClick={e => actionHandler('edit', row)}>
                                                                            <i className='fa fa-edit' />
                                                                        </button>
                                                                        <button className='btn action-btn' onClick={e => actionHandler('delete', row)}>
                                                                            <i className='fa fa-trash-o' />
                                                                        </button>
                                                                    </td>
                                                                    {/* : ""} */}
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <Pagination
                                                count={Math.ceil(totalcount / itemsPerPage)}
                                                page={currentPage}
                                                onChange={handlePageChange}
                                                color="success" variant="outlined" shape="rounded"
                                                style={{ display: 'flex', justifyContent: 'end' }}
                                            />

                                        </>
                                        :
                                        <p style={{ marginTop: '100px' }} className="text-center">
                                            <img src={NodataImage} style={{ width: '30%' }} alt="No data available" />
                                        </p>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    : ''}
            {
                view === "add" || view === "edit" ?
                    <div className="communitySection" style={{ marginTop: '30px' }}>
                        <div style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer', margin: '30px 0' }} onClick={e => actionHandler('list', "")}>
                            <KeyboardDoubleArrowLeftIcon /> &nbsp; Back to list
                        </div>
                        <div className='container hoverNone card'>
                            <PiePage
                                totalPage={1}
                                currentPage={1}
                                heading={'Add Document Name'}
                            />

                            <div className="row" style={{ marginBottom: '12px' }}>
                                <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                                    <InputField
                                        label="Document Name"
                                        variant="outlined"
                                        value={documentName}
                                        name="documentName"
                                        id="documentName"
                                        type="text"
                                        onChange={e => setdocumentName(e)}
                                        size="small"
                                    // required={true}
                                    />

                                </div>
                            </div>
                            <div className='mb-3 mt-2 row' style={{ margin: '20px 0 15px 0' }}>

                                <div className="col-12 text-center">

                                    <button className="cred-btn" disabled={documentName == "" || documentName == undefined || documentName == null ? true : false} style={{ fontSize: '16px' }} onClick={e => saveHandler(e)}>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ''}
        </>
    )
}
